import jquery from "jquery";
window.$ = window.jQuery = jquery;
import Flickity from 'flickity';

const selectors = {
  awardsList: '.awards-list',
}


document.addEventListener("DOMContentLoaded", function () {
  const $carousel = $(selectors.awardsList);
  if (!!$carousel.length) {
    var flkty = new Flickity( selectors.awardsList, {
      percentPosition: true,
      contain: false,
      wrapAround: true,
      groupCells: true,
      pageDots: true,
      imagesLoaded: true,
      adaptiveHeight: true,
      resize: false,
      prevNextButtons: false,
    });
  }
});



